var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClockOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#F6A11D"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.333 11.111H10c-.613 0-1.111-.497-1.111-1.111V6.667c0-.615.498-1.111 1.111-1.111s1.111.496 1.111 1.11V8.89h2.222c.614 0 1.111.497 1.111 1.111s-.497 1.111-1.11 1.111M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10z",
    transform: "translate(-49.000000, -912.000000) translate(49.000000, 912.500000)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClockOrange);
export default __webpack_public_path__ + "static/media/icon-clock--orange.3baac2d79b48f140830dc1b858d35c7b.svg";
export { ForwardRef as ReactComponent };